const customModalHomeAdminForm = {
  'custom-home-modal-admin-form-message-label': 'Homepage image',
  'custom-home-modal-admin-title': 'Custom homepage modal',
  'custom-home-modal-admin-description': 'Manage the image and visibility of the homepage modal.',
  'custom-home-modal-admin-form-status-label-deactivated': 'Activate',
  'custom-home-modal-admin-form-status-label-activated': 'Deactivate',
  'custom-home-modal-admin-error-required': 'This field is required.',
  'custom-home-modal-admin-subbmiting-message': 'Saving modal configuration...',
  'custom-home-modal-admin-img-loader-info': 'Upload an image to be shown in the homepage modal.',
  'custom-home-modal-admin-getting-details': 'Getting home image details...',
  'custom-home-modal-admin-image-setting-successfull': 'Home image has been set successfully',
  'custom-home-modal-admin-boton-change-img': 'Change image',
  'custom-home-modal-admin-boton-accept': 'Accept',
  'custom-home-modal-admin-boton-show-modal': 'View home banner',
  'custom-home-modal-admin-img-not-found': 'Image not found or set yet'
};

export default customModalHomeAdminForm;
